import type { HostPoolUUID, HostPoolWithType } from "@/modules/pools/hostPoolsQuery.ts";
import { first } from "remeda";

export function getDefaultHostPool(pools: HostPoolWithType[], defaultHostPool: HostPoolUUID | null | undefined) {
    return pools.find((s) => s.uuid === defaultHostPool) ?? pools.find((s) => s.is_default_designated) ?? first(pools);
}
